<!--  -->
<template>
  <div>
    <div class="tabselecr_box">
      <div style="display: flex;align-items: center;" class="search_box">
        <!-- <el-input v-model="query.sp_strategy_no" clearable style="width:280px;margin-right:10px" placeholder="请输入策略编号" />
        <el-input v-model="query.sp_strategy_title" clearable style="width:280px;margin-right:10px" placeholder="请输入策略标题" /> -->
        <el-input v-model="query.keywords" clearable style="width:400px;" placeholder="请输入客户id/群聊id" />
        <el-button type="primary" style="margin:0px 10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
        <div class="maewrr" style="margin: 0 50px;">消息推送成功数量：{{ success_count }}</div>
        <div class="maewrr">失败数量：{{ fail_count }}</div>
      </div>
      <!-- <div>
        <el-button type="success" icon="el-icon-plus" @click="add">新增策略</el-button>
      </div> -->
    </div>
    <el-table
      v-loading="listLoading"
      :data="tabledata"
      max-height="550"
      border
    >
      <el-table-column
        prop="msg_id"
        width="310"
        label="消息id"
        align="center"
      />
      <el-table-column
        prop="name"
        width="100"
        label="发送人"
        align="center"
      />
      <el-table-column
        prop="external_userid"
        label="客户名称(客户id) / 群聊名称(群聊id)"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.mark_name_text }}
          <!-- {{ scope.row.external_username }}（{{ scope.row.external_user_id }}） -->
        </template>
      </el-table-column>
      <el-table-column
        prop="send_time_text"
        width="180"
        label="发送时间"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        width="180"
        label="创建时间"
        align="center"
      />
      <!-- <el-table-column
        prop="status_text"
        label="发送状态"
        align="center"
      /> -->

      <el-table-column
        prop="status_text"
        label="发送状态"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="发送状态"
            width="200"
            trigger="hover"
            :content="scope.row.status_text"
          >
            <p
              slot="reference"
              class="titip"
            >{{ scope.row.status_text }}</p>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { timingPushRecordDetails /* spgetSentresult */ } from '@/api/officialaccount.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      listLoading: false,
      query: {
        msg_id: null,
        page: 1,
        pageSize: 10,
        user_id: null,
        keywords: null
      },
      tabledata: [],
      total: null,
      success_count: '',
      fail_count: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      this.query.msg_id = item.msg_id
      this.query.user_id = item.user_id
      this.success_count = item.success_count
      this.fail_count = item.fail_count
      this.list()
    },
    async list() {
      this.listLoading = true
      // const datar = await spgetSentresult({
      //   user_id: this.query.user_id,
      //   msg_id: this.query.msg_id
      // })
      const data = await timingPushRecordDetails(this.query)
      this.tabledata = data.data.list
      this.total = data.data.total
      this.listLoading = false
      console.log('data', data)
      // console.log('datar', datar)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      // this.query.sp_strategy_no = null
      // this.query.sp_strategy_title = null
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.titip{
    width: 180px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    overflow: hidden;
}
.maewrr{
  font-size: 19px;
  color: #F56C6C;
}
</style>
